import { Button } from '@bpinternal/ui-kit-next'
import { ExternalLink } from 'lucide-react'
import { ReactNode } from 'react'
import { cn } from '~/utils'

type AddKnowledgeSourceFooterProps = {
  linkName: string
  linkHref: string
  showCancel?: boolean
  onClose: () => void
  primaryAction: ReactNode
}

export const AddKnowledgeSourceFooter = ({
  linkName,
  linkHref,
  showCancel = true,
  onClose,
  primaryAction,
}: AddKnowledgeSourceFooterProps) => {
  return (
    <div className={'-mx-6 mt-6 gap-4 rounded-b-lg border-t p-6 text-foreground @container'}>
      <div
        className={cn(
          'flex w-full flex-col @lg:flex-row @lg:justify-between md:items-center',
          showCancel && 'gap-4 @lg:gap-6'
        )}
      >
        <a
          className="flex items-center justify-center gap-2 text-xs text-muted-foreground hover:text-primary hover:underline lg:justify-start lg:text-sm"
          href={linkHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          <ExternalLink size={16} />
          <p>{linkName}</p>
        </a>
        <div className="flex items-center justify-center gap-2">
          {showCancel && (
            <Button onClick={onClose} variant="outline" size="sm" className="hidden @lg:block">
              Cancel
            </Button>
          )}
          <div className="h-12 w-full *:h-full *:w-full @lg:h-8">{primaryAction}</div>
        </div>
      </div>
    </div>
  )
}
